import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/faqs';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-white px-4 py-5" data-id="element-33" data-mp="1hcrwc7ansus8">
      <div className="mx-auto max-w-3xl" data-id="element-34" data-mp="1hduloasc2p61">
        <h2 className="mb-2 text-center font-display text-lg font-extrabold uppercase leading-tight sm:text-3xl" data-id="element-35" data-mp="1cf05zhpnxgq5">
          Questions fréquentes
        </h2>
        <div className="space-y-1.5" data-id="element-36" data-mp="2a05xkhle4ci5">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          const panelId = `faq-panel-${index}`;
          return <article key={faq.question} className="overflow-hidden rounded-xl border border-brand-line bg-brand-cream" data-id="element-37" data-mp="20281j7xahbez" data-mpi={index}>
                <h3 data-id="element-38" data-mp="opp0jmxday5o">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} className="flex w-full items-center justify-between gap-3 px-3 py-2.5 text-left" aria-expanded={isOpen} aria-controls={panelId} data-id="element-39" data-mp="oq75d7y3ikp7">
                    <span className="font-display text-[13px] font-semibold leading-snug text-brand-ink sm:text-base" data-id="element-40" data-mp="1apsu2tf75j9a">
                      {faq.question}
                    </span>
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand-orange transition-transform duration-150 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-41" data-mp="1fqgid7c1jlzt" />
                  </button>
                </h3>
                {isOpen && <p id={panelId} className="px-3 pb-2.5 text-xs font-medium leading-snug text-brand-muted sm:text-sm" data-id="element-42" data-mp="wynufrbtwqyy">
                    {faq.answer}
                  </p>}
              </article>;
        })}
        </div>
      </div>
    </section>;
}